<template>
  <SelectorPanel
    v-if="isLatestFeatureUnlocked"
    type="latest"
    text="Latest"
    :disabled="disabled"
    :force-close="forceClose"
  >
    <SelectorPanelHeader
      type="latest"
      title="Latest"
      class="pb-2"
      @click-close="handleClickClose"
    >
    </SelectorPanelHeader>

    <Latest />
  </SelectorPanel>
</template>

<script>
import { isFeatureUnlocked } from "@/common/featureLock.js";

export default {
  name: "LatestSelector",
  components: {
    SelectorPanel: () => import("@/components/common/SelectorPanel"),
    Latest: () => import("@/components/latest/Latest"),
    SelectorPanelHeader: () =>
      import("@/components/common/SelectorPanelHeader"),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLatestFeatureUnlocked: false,
    forceClose: null,
  }),
  mounted() {
    this.isLatestFeatureUnlocked = isFeatureUnlocked("latest-dashboard");
  },
  methods: {
    handleClickClose() {
      this.forceClose = new Date().toISOString();
    },
  },
};
</script>

<style scoped></style>
